import { render } from "./index2.vue?vue&type=template&id=7a7e673c"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"

import "./index2.vue?vue&type=style&index=0&id=7a7e673c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__